<template>

      <v-navigation-drawer
          app
          dark
          v-model="drawer"
          :src="barImage"

          right

          class="v-navigation-drawer__content"

  >

        <v-toolbar :disabled="true" style="display: block;" color="#111877"  >
          <v-avatar  class="m-1" @click="$router.push('/profile')">
            <v-img  :src="imgPro"/>
          </v-avatar>
                
          <span  class="mr-2 " >{{ currentUser }}</span>

        </v-toolbar>
        <v-divider  class="ma-0 pa-0 orange"/>



        <section id="style-1" style="overflow-y: auto!important;height: 90vh ">

          <v-list-group
              :value="true"
              no-action
              sub-group
              v-for="(item ,j) in menuList" :key="j"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{item.title}}</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
                v-for="(child,i) in item.menuDTOList"
                :key="i"
                :to="child.to"
                link
                color="warning"
            >
              <v-icon  dark>
                {{child.iconName}}
              </v-icon>
              <v-list-item-content>
                <v-list-item-title v-text="child.title"/>
              </v-list-item-content>
            </v-list-item>
            <div style="height: 100px"/>
          </v-list-group>




<!--          <v-list>-->


<!--<v-col v-for="(item ,j) in menuList" :key="j">-->
<!--              <v-list-item-->
<!--                  v-for="(child,i) in item.menuDTOList"-->
<!--                  :key="i"-->
<!--                  :to="child.to"-->
<!--                  link-->
<!--                  color="warning"-->
<!--              >-->
<!--                <v-icon  dark>-->
<!--                  {{child.iconName}}-->
<!--                </v-icon>-->
<!--                <v-list-item-content>-->
<!--                  <v-list-item-title v-text="child.title"/>-->
<!--                </v-list-item-content>-->
<!--              </v-list-item>-->
<!--</v-col>-->

<!--            </v-list-group>-->

<!--            <div style="height: 100px"/>-->


<!--          </v-list>-->
        </section>

      </v-navigation-drawer>

</template>


<script>
import colors from 'vuetify/lib/util/colors'
import { mapState} from "vuex";

export default {

  data: () => {
    return {
      imgPro: require('../../assets/pro.png'),
      menuList:[],
      currentUser:'',
      orange:colors.orange.darken3,
    }

  },

  name: "SideBar",
  computed: {
    ...mapState(['drawer','barColor', 'barImage', 'mini']),
  },

  methods:{

    mapItem () {
      const state = JSON.parse(localStorage.getItem('vuex-state'));
      this.currentUser = state.userName;
      this.menuList=this.$store.state.menuList

    },
  },
  created() {
    this.mapItem()
  }

}
</script>

<style>
.v-navigation-drawer__content {
  height: 100%;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  background:#111877;
  opacity: .90;

}

#style-1::-webkit-scrollbar {
  width: 2px;
  background-color: #F5F5F5;
}

#style-1::-webkit-scrollbar-thumb {
  background-color: #F90;
  background-image: -webkit-linear-gradient(90deg, rgba(255, 255, 255, .2) 25%,orange,
  orange)
}

#style-1::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #F5F5F5;
}

/*.drawer-style {*/
/*  !*background-color: #2196F3 !important;*!*/
/*  border-color: #2196F3 !important;*/
/*}*/

</style>


